import { EditOutlined, VisibilityOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";

/**
 * @param {{
 *   mode: 'view' | 'edit',
 *   onModeChange: (nextMode: 'view' | 'edit') => void,
 * }} props
 */
function PriceHistoryRecordViewToggle({ mode, onModeChange }) {
  const isViewMode = mode === "view";
  const nextMode = isViewMode ? "edit" : "view";
  const buttonLabel = isViewMode ? "Edit" : "View";

  return (
    <Button
      variant="outlined"
      color="secondary"
      size="small"
      startIcon={isViewMode ? <EditOutlined /> : <VisibilityOutlined />}
      aria-label={isViewMode ? "Switch to edit mode" : "Switch to view mode"}
      aria-pressed={mode === "edit"}
      onClick={() => onModeChange(nextMode)}
    >
      {buttonLabel}
    </Button>
  );
}

export default PriceHistoryRecordViewToggle;
